import {
    Component,
    Input,
    Output,
    EventEmitter,
    AfterViewInit
} from '@angular/core';
import {
    FormGroup,
    FormControl,
    ValidatorFn,
    ValidationErrors
} from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, combineLatest } from 'rxjs/operators';

const validator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const shard = control.get('shard').value;
    const room = control.get('room').value;

    if (shard || room) {
        return null;
    }

    return { invalid: true };
};

@Component({
    selector: 'app-decoration-rooms-select',
    templateUrl: './decoration-rooms-select.component.pug',
    styleUrls: ['./decoration-rooms-select.component.less']
})
export class DecorationRoomsSelectComponent implements AfterViewInit {
    roomsGridView: boolean = false;

    public params: FormGroup = new FormGroup({
        shard: new FormControl(''),
        room: new FormControl('')
    }, { validators: validator });

    get paramsRoom() {
        return this.params.value.room;
    }

    get paramsShard() {
        return this.params.value.shard;
    }

    _loadingSbj: BehaviorSubject<boolean> = new BehaviorSubject(true);
    loading$: Observable<boolean> = this._loadingSbj.asObservable();

    _decorationsSbj: BehaviorSubject<any[]> = new BehaviorSubject([]);
    decorations$: Observable<any[]> = this._decorationsSbj.asObservable();
    @Input() set decorations(decorations: any[]) {
        this._decorationsSbj.next(decorations);
    }

    _shardsSbj: BehaviorSubject<[string, any[]][]> = new BehaviorSubject([]);
    shards$: Observable<IAppSelectOption[]> = this._shardsSbj.asObservable()
        .pipe(map((shards) => shards.map(([name]) => ({ name, value: name }))))
        .pipe(map((options) => [{ value: '', name: 'All' }, ...options]));

    rooms$: Observable<any> = this._shardsSbj.asObservable()
        .pipe(combineLatest(this.params.valueChanges))
        .pipe(map(([shards, { shard, room }]) => shards.reduce((shards, [name, rooms]) => {
            if (shard && shard !== name) {
                return shards;
            }

            const shardRooms = [];
            const shardReservation = [];

            rooms.forEach((_) => {
                if (!_.room.toUpperCase().includes(room.toUpperCase())) {
                    return;
                }

                (_.reservation ? shardReservation : shardRooms).push(_);
            });

            if (shardRooms.length) {
                shards.push({ name, rooms: shardRooms });
            }

            if (shardReservation.length) {
                shards.push({ name, rooms: shardReservation, reservation: true });
            }

            return shards;
        }, [])));

    roomsLength$: Observable<boolean> = this.rooms$
        .pipe(map((rooms) => rooms && rooms.length));

    @Input() required: boolean = true;

    @Input() set rooms(rooms: IUserRooms | null) {
        if (!rooms) {
            return;
        }

        this._shardsSbj.next(Object.entries(rooms));
        this._loadingSbj.next(false);
    }

    @Input() set settings({ shard }) {
        if (!shard) {
            return;
        }

        this.params.patchValue({ shard });
    }

    @Input() user: any;

    @Output() room: EventEmitter<any> = new EventEmitter();
    @Output() shard: EventEmitter<any> = new EventEmitter();
    @Output() activate: EventEmitter<void> = new EventEmitter();

    constructor(
    ) {
    }

    async ngAfterViewInit() {
        await delay(0);

        this.params.patchValue({
            shard: ''
        });
    }

    onSelectRoom(shard, room) {
        this.shard.emit(shard);
        this.room.emit(room);
    }

    onActivate() {
        this.activate.emit();
    }

    trackByShardNameFn(index, item) {
        return item.name;
    }

    trackByRoomNameFn(index, item) {
        return item.room;
    }
}

function delay(timeout: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, timeout));
}
